module.exports = __webpack_public_path__ + "4ae94e6aca9eebcba937ad984e5f055b.MP3";